module.exports = __webpack_public_path__ + "static/media/404_background.c1ec2ca0.png";